import React from "react";
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import { useEffect, useState } from "react";
import { authenticationService } from "../../services";
import { AppBarCenter, LogoText, useStyles, MenuLink } from "./MainPageStyles";
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { BackgroundCurve, ContentCurve } from "./Page";
import Footer from "../Footer/Footer";
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PhoneForwardedIcon from '@material-ui/icons/PhoneForwarded';
import ListIcon from '@material-ui/icons/List';
import InstyleMenuItem from "../Menu/InstyleMenuItem";
import { ConfigPath } from '../../pages/Config';
import { ReadyToDialPath } from '../../pages/ReadyToDial';
import { CallLogsPath } from '../../pages/CallLogs';
import { LogoutPath } from '../../pages/Logout';
import PageviewIcon from '@material-ui/icons/Pageview';
import { CampaignPath, Campaigns } from '../../pages/Campaigns';
import AssessmentIcon from '@material-ui/icons/Assessment';
import EditIcon from '@material-ui/icons/Edit';
import { CampaignUserPath } from "../../pages/CampaignUsers";
import PeopleIcon from '@material-ui/icons/People';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import { CallQueuePath } from "../../pages/CallQueue";
import { DuplicatePath } from "../../pages/Duplicates";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CallAttemptsPage, { CallAttemptsPath } from "../../pages/CallAttempts";
import DashboardIcon from '@material-ui/icons/Dashboard';
import { DashboardPath } from "../../pages/Dashboard";
import { ExportPath } from "../../pages/Exports";
import ImportExportIcon from '@material-ui/icons/ImportExport';

function Page (props) {
  const [ loggedIn, setLoggedIn ] = useState(authenticationService.currentUserValue);

  const theme = useTheme();
  const classes = useStyles(theme);

  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  useEffect(() => {
    authenticationService.currentUser.subscribe(x => {
      setLoggedIn(authenticationService.currentUserValue);
    });
  });

  return (
    <>
      {loggedIn ?
      <LoggedInPage/>
      :
      <LoggedOutPage/>}
    </>
  );


  function LoggedInPage() {
    return (
      <div className={classes.root}>
        <AppBar
          position="fixed"
          className={clsx(classes.instyleAppBar, {
            [classes.instyleAppBarShift]: open,
          })}
          >
          <Toolbar>
            {
              !open && <IconButton edge="start" color="inherit" aria-label="menu" onClick={() => setOpen(true)}>
                          <MenuIcon />
                      </IconButton>
            }
            <AppBarCenter >
              <LogoText>Dialler</LogoText> by Instyle Solar
            </AppBarCenter>
          </Toolbar>
        </AppBar>
        <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton style={{color: "var(--color-white)"}} onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider style={{backgroundColor: "var(--color-white)"}} />
        <List>
          <InstyleMenuItem to={ConfigPath} label="Config" icon={<SettingsIcon />} />
          {/* <InstyleMenuItem to={DashboardPath} label="Dashboard" icon={<DashboardIcon />} /> */}
        </List>
        <List>
          <InstyleMenuItem to={''}
            label={'Campaigns'}
            icon={<AssessmentIcon/>}
            items={[
              <InstyleMenuItem to={CampaignPath} label="Create/Edit" icon={<EditIcon />} />,
              <InstyleMenuItem to={CampaignUserPath} label="Manage Users" icon={<PeopleIcon />} />
            ]}
            />
        </List>
        <List>

          <InstyleMenuItem
            to={''}
            label="Reports"
            icon={<PageviewIcon/>}
            items={[
              <InstyleMenuItem to={CallAttemptsPath} label="Call Attempts" icon={<AccessTimeIcon />} />,
              <InstyleMenuItem to={DuplicatePath} label="Duplicate Calls" icon={<FileCopyIcon />} />,
              <InstyleMenuItem to={ReadyToDialPath} label="Ready To Dial" icon={<PhoneForwardedIcon />} />,
              <InstyleMenuItem to={CallLogsPath} label="Call Logs" icon={<ListIcon />} />,
              <InstyleMenuItem to={CallQueuePath} label="Call Queue" icon={<EqualizerIcon />} />,
              <InstyleMenuItem to={ExportPath} label="Exports" icon={<ImportExportIcon />} />
            ]}

          />
        </List>
        <Divider style={{backgroundColor: "var(--color-white)"}} />
        <List>
          <InstyleMenuItem onClick={() => setOpen(false)} to={LogoutPath} label="Logout" icon={<ExitToAppIcon />} />
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        { BackgroundCurve() }
        { props.children }

        { ContentCurve() }
      </main>
      <Footer />
      </div>
    )
  }

  function LoggedOutPage() {
    return (
      <div className={classes.root}>
        <AppBar
          position="fixed"
          className={clsx(classes.instyleAppBar, {
            [classes.instyleAppBarShift]: open,
          })}
          >
          <Toolbar>
            <AppBarCenter >
              <LogoText>Dialler</LogoText> by Instyle Solar
            </AppBarCenter>
          </Toolbar>
        </AppBar>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        { BackgroundCurve() }
        { props.children }

        { ContentCurve() }
      </main>
      <Footer />
      </div>
    )
  }
}

export default Page;
